import { SCREENS } from './screens';

/** 경로 상수. 파라미터 경로는 buildPath 로 채운다. */
export const PAGE_PATHS = {
  WELCOME: SCREENS.welcome.path,
  HOME: SCREENS.home.path,
  SEARCH: SCREENS.search.path,
  DIAGNOSIS: SCREENS.diagnosis.path,
  DIAGNOSIS_RESULT: SCREENS.diagnosisResult.path,
  AUTH: SCREENS.auth.path,
  EXPLORE: SCREENS.explore.path,
  EXPLORE_MAP: SCREENS.exploreMap.path,
  EXPERIENCE_DETAIL: SCREENS.experienceDetail.path,
  TREATMENT_DETAIL: SCREENS.treatmentDetail.path,
  CLINIC_DETAIL: SCREENS.clinicDetail.path,
  QUESTIONS: SCREENS.questions.path,
  QUESTION_DETAIL: SCREENS.questionDetail.path,
  JOURNEYS: SCREENS.journeys.path,
  JOURNEY_DETAIL: SCREENS.journeyDetail.path,
  TRENDS: SCREENS.trends.path,
  TREND_DETAIL: SCREENS.trendDetail.path,
  CHAT: SCREENS.chat.path,
  CHAT_ROOM: SCREENS.chatRoom.path,
  PLANS: SCREENS.plans.path,
  PRODUCTS: SCREENS.products.path,
  PRODUCT_DETAIL: SCREENS.productDetail.path,
  CHECKOUT: SCREENS.checkout.path,
  CHECKOUT_COMPLETE: SCREENS.checkoutComplete.path,
  TRIP: SCREENS.trip.path,
  ITINERARY: SCREENS.itinerary.path,
  PLANNER: SCREENS.planner.path,
  BOOKINGS: SCREENS.bookings.path,
  BOOKING_DETAIL: SCREENS.bookingDetail.path,
  TRAVEL_INFO: SCREENS.travelInfo.path,
  SAVED: SCREENS.saved.path,
  RECENT: SCREENS.recent.path,
  AFTERCARE_LIST: SCREENS.aftercareList.path,
  AFTERCARE: SCREENS.aftercare.path,
  MY: SCREENS.my.path,
  SETTINGS: SCREENS.settings.path,
  MEMBERSHIP: SCREENS.membership.path,
  POINTS: SCREENS.points.path,
  VOUCHERS: SCREENS.vouchers.path,
  VOUCHER_DETAIL: SCREENS.voucherDetail.path,
  VOUCHER_ORDER: SCREENS.voucherOrder.path,
  COUPONS: SCREENS.coupons.path,
  REVIEWS: SCREENS.reviews.path,
  PAYMENTS: SCREENS.payments.path,
  BOOKING_REVIEW: SCREENS.bookingReview.path,
  NOTIFICATIONS: SCREENS.notifications.path,
  HELP: SCREENS.help.path,
  LEGAL: SCREENS.legal.path,
  NOT_FOUND: SCREENS.notFound.path,
} as const;

/** buildPath('/clinics/:slug', { slug: 'jfeel' }) → '/clinics/jfeel'. 선택 파라미터(:x?)는 값이 없으면 제거한다. */
export function buildPath(
  path: string,
  params: Record<string, string | number | undefined> = {},
) {
  return path
    .replace(/\/:([A-Za-z]+)\?/g, (_, name: string) =>
      params[name] === undefined
        ? ''
        : `/${encodeURIComponent(String(params[name]))}`,
    )
    .replace(/:([A-Za-z]+)/g, (_, name: string) =>
      encodeURIComponent(String(params[name] ?? '')),
    );
}
